import {create} from "zustand"
import {shallow} from "zustand/shallow"

interface State {
    finished: boolean
    enableFinished: Function
    step: number
    nextStep: Function
    prevStep: Function
}

const useStore = create<State>((set, get) => ({
    finished: false,
    step: 1,
    prevStep: () => set(state => ({step: get().step - 1})),
    nextStep: () => set(state => ({step: get().step + 1})),
    enableFinished: () => {set({finished: true})},
}))

export const useFormSteps = () => useStore((state: State) => state, shallow)